import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { App } from './app';
import './styles.css';

const root = document.getElementById('root')!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// Das Schaufenster (/, /impressum, /datenschutz) kommt vorgerendert vom Server (web/scripts/prerender.mjs,
// Wurzel mit data-site="platform"): React belebt das vorhandene HTML, statt es neu zu zeichnen.
if (root.dataset['site'] === 'platform') hydrateRoot(root, app);
else createRoot(root).render(app);
